import React from 'react';
import { graphql } from 'gatsby';
import { Container } from 'components/UI/Container/Container';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import { PrismicLink } from 'components/PrismicLink';
import { PageContextType } from '../types';
import { LinkFragments, MetaFragment } from './fragments.gql';
import './PageNotFound.scss';
import { PageNotFoundDataType } from './types';
import { UnpublishedPageNotFoundData } from './pageData';

export type PageNotFoundTemplateProps = {
    location: Location;
    pageContext: PageContextType;
    data?: {
        prismic: {
            not_found_page?: PageNotFoundDataType;
        };
    };
};

const PageNotFoundTemplate: React.FC<PageNotFoundTemplateProps> = ({ data }) => {
    const page = (data && data.prismic && data.prismic.not_found_page) || UnpublishedPageNotFoundData;
    return (
        <Container className="PageNotFound" size="lg">
            <Grid>
                <GridRow horizontalAlign="h-center">
                    <GridCol className="PageNotFound-content">
                        <p className="PageNotFound-secondaryText">{page.not_found_small_text}</p>
                        <p className="PageNotFound-primaryText">{page.not_found_large_text}</p>
                        <PrismicLink link={page.not_found_button_link} className="Button Button--primary Button--small">
                            <div className="Button-wrapper">
                                <div className="Button-text">{page.not_found_button_text}</div>
                            </div>
                        </PrismicLink>
                    </GridCol>
                </GridRow>
            </Grid>
        </Container>
    );
};

// NOTE: This variable must ALWAYS remain named `query` or Prismic previews will break
export const query = graphql`
    query($uid: String!, $lang: String!) {
        prismic {
            not_found_page(uid: $uid, lang: $lang) {
                ...MetaFragment
                not_found_small_text
                not_found_large_text
                not_found_button_text
                not_found_button_link {
                    ...LinkFragment
                }
            }
        }
    }
`;

// We must manually add `fragments` property to the component for Prismic previews to work
// @ts-ignore
PageNotFoundTemplate.fragments = [LinkFragments, MetaFragment];

export default PageNotFoundTemplate;
